/**
 * config = {
 *  x: number,
 *  y: number
 * }
 */

G.UI_DailyIcon = function(config) {

	this.active = G.saveState.getLastPassedLevelNr() >= G.featureUnlock.unlockLevels.dailyWheel;
	this.tutorial = false; //this.active && !G.saveState.data.sawDailyTut;

	this.state = game.state.getCurrentState();
	
  Phaser.Group.call(this,game);
  this.dailyIconContainer = new Phaser.Group(game);
  
  this._config = config || {};
  this.ignorePosition = !(this._config.x || this._config.y);
  if (!this.ignorePosition) {
    this.x = G.l(x);
    this.y = G.l(y);
  }

	this._addIcon();

	if (this.active) {
		// this.addGlow();
		this.addTimerAndFreeText();
	} else {
		this.addUnlockTxt();
	}

  this.notificationBubble = new G.NotificationBubble(30, -40);
  this.dailyIconContainer.add(this.notificationBubble);

  this.add(this.dailyIconContainer);
	this.update();

	if (this.tutorial){
		this._tutHand = G.makeImage(0,20,'tut_hand',0,this);
		game.add.tween(this._tutHand).to({x:G.l(20),y:G.l(50)},300,Phaser.Easing.Sinusoidal.InOut,true,0,-1,true);
  };
  
  if (!this.ignorePosition) {
    G.sb("onScreenResize").add(this.onResize,this);
    this.onResize();
  }

  OMT.platformTracking.logFTUEvent('FTUX_SpinWheelUnlock');
};

G.UI_DailyIcon.prototype = Object.create(Phaser.Group.prototype);

G.UI_DailyIcon.prototype.update = function() {

	if (this.active) {
		this.freeText.visible = G.saveState.data.freeSpin;
    this.icon.adIcon.visible = !G.saveState.data.freeSpin;
    this.notificationBubble.setImportant(G.saveState.data.freeSpin);
    if (game.incentivised()) {
      this.timer.visible = false;
    } else {
      this.timer.visible = !this.freeText.visible;
    }
	} else {
    this.notificationBubble.setImportant(false);
    this.icon.adIcon.visible = false;
  }


};

G.UI_DailyIcon.prototype.onResize = function(){
	var center = game.world.bounds.x+Math.floor(game.width*0.5);
	this.x = center+G.OMTsettings.elements.dailyIcon.xCenterOffset;
};

G.UI_DailyIcon.prototype._addIcon = function (){
	this.icon = new G.Button(0, 0,'new_wheel_menu',function() {
		if (!this.active) return;
    if (!game.incentivised() && !G.saveState.data.freeSpin) return;
    G.sb("pushWindow").dispatch(['dailyWheel', {
      worldState: true,
      asMoreMoney: false,
    }], false, G.WindowMgr.LayerNames.BelowHeaderPanel);
    G.sb("hideMainHighscorePanel").dispatch();

		if (this.tutorial) {		
			if (this._tutHand) {
				this._tutHand.destroy();
			}
			G.saveState.data.sawDailyTut = true;
			G.saveState.save();
			G.sb("onWindowClosed").addOnce(function(){
				var state = game.state.getCurrentState();
				if (state.lvlTutHand) {
					game.add.tween(state.lvlTutHand).to({alpha:1},500,Phaser.Easing.Sinusoidal.Out,true);
				}
			});
		}

	},this);

  this.icon.adIcon = G.makeImage(0, 20,"video_wheel_menu", 0.5, this.icon);
  game.add.tween(this.icon.adIcon.scale)
    .to({x: 1.2, y: 1.2}, 1000, Phaser.Easing.Sinusoidal.InOut,true, 0, -1, true);
  this.icon.adIcon.angle = -4;
  game.add.tween(this.icon.adIcon)
    .to({angle: 4}, 2000, Phaser.Easing.Sinusoidal.InOut,true,0,-1, true);
  this.dailyIconContainer.add(this.icon);


  if (!game.incentivised()) {
    this.icon.adIcon.renderable = false;
  }

};

G.UI_DailyIcon.prototype.onClick = function(extraArgs) {
  if (!game.incentivised() && !G.saveState.data.freeSpin) return;
  const dailyWheelArgs = {
    worldState: true,
    asMoreMoney: false,
  };
  if (extraArgs) {
    _.forEach(extraArgs, (value, key) => {
      dailyWheelArgs[key] = value;
    });
  }
  G.sb("pushWindow").dispatch(['dailyWheel', dailyWheelArgs], false, G.WindowMgr.LayerNames.BelowHeaderPanel);
  G.sb("hideMainHighscorePanel").dispatch();
}

G.UI_DailyIcon.prototype.addGlow = function() {
	this.glow = G.makeImage(0, 0,'popup_lighht',0.5,this);
	this.glow.alpha = 0.5;
this.glow.scale.setTo(0.5);
	this.glow.blendMode = 1;
	this.glow.update = function(){this.angle++};
	this.sendToBack(this.glow);
};

G.UI_DailyIcon.prototype.addTimerAndFreeText = function(){
  this.timer = new G.TextTimer(0, 7, null, {
    style: "font-num-blue",
    fontSize: "30px"
  }, 0.5, 130);
  this.timer.setSecLeft((G.saveState.data.lastDaily+86400000-Date.now())/1000);
  this.timer.active = true;
  this.dailyIconContainer.add(this.timer);

  G.sb("onDailyFreeSpinGain").add(function() {
    this.timer.setSecLeft((G.saveState.data.lastDaily+86400000-Date.now())/1000);
  },this);


	this.freeText = new G.Text(0, 0, OMT.language.getText('Free spin!'), "ui-dailyIcon",0.5,150,150, true, 'center');
  this.freeText.lineSpacing = -15;
  this.freeText.setShadow(0, 0, 'black', 3);
	this.dailyIconContainer.add(this.freeText);

	game.add.tween(this.freeText.scale).to({x:0.9,y:0.9},500,Phaser.Easing.Sinusoidal.InOut,true,0,-1,true);
};

G.UI_DailyIcon.prototype.addUnlockTxt = function(lvl){

	this.unlockTxt = new G.Text(0, 0, OMT.language.getText('Unlock at Level X').replace('X',G.featureUnlock.unlockLevels.dailyWheel+1), {
    style: "font-white",
    fontSize: G.OMTsettings.elements.dailyIcon.unlockTxt.fontSize
  },0.5,150,150, true, 'center');
  this.unlockTxt.lineSpacing = -15;
  // this.unlockTxt.setShadow(0, 0, 'black', 3);
	this.dailyIconContainer.add(this.unlockTxt);

	game.add.tween(this.unlockTxt.scale).to({x:0.9,y:0.9},500,Phaser.Easing.Sinusoidal.InOut,true,0,-1,true);

};
